import React from "react";

export default function TJsvg() {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="60.000000pt"
            height="72.000000pt"
            viewBox="0 0 53.000000 72.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(-9,72.000000) scale(0.100000,-0.100000)" fill="var(--theme-blue)" stroke="none">
                <path d="M380 442 c0 -318 -1 -322 -71 -322 -61 0 -89 40 -89 126 l0 45 -67 -3 -68 -3 3 -69 c6 -158 87 -225 256 -214 80 5 134 38 165 100 20 42 21 59 21 331 l0 287 -75 0 -75 0 0 -278z"></path>
            </g>
            <g
                transform="rotate(-180 28 35) translate(0.000000,72.000000) scale(1.100000,-1.100000) "
                fill="var(--theme-red)"
                stroke="none"
            >
                <path d="M 32 72 L 22 70 L 21.5 8.4 L 0 8.4 L 0 0 L 52.5 0 L 52.5 8.4 L 31 8.4 L 31 70 Z"></path>
            </g>
        </svg>
    );
}
